<template>
    <section class="section section--partner-operators" v-if="this.$root.selectedCountry.name == 'Liechtenstein' || this.$root.selectedCountry.name == 'Turkmenistan'">
        <div class="spring">
            <h2 class="heading heading--3 heading--center">Operatori parteneri</h2>
            <div class="card">
                <table class="table--alt table--partners table">
                    <thead>
                        <tr class="table__tr">
                            <th class="table__th">Operator</th>
                            <th class="table__th">Nume afișaj</th>
                            <th class="table__th">Tipul rețelei</th>
                        </tr>
                    </thead>
                    <tbody class="table__body">
                        <tr class="table__tr">
                            <td class="table__td">
                                <strong>{{ this.$root.selectedCountry.partnerOperator }}</strong>
                            </td>
                            <td class="table__td">
                                <strong>{{ this.$root.selectedCountry.partnerOperatorScreenName }}</strong>
                            </td>
                            <td class="table__td">
                                <strong>{{ this.$root.selectedCountry.partnerBandwidth }}</strong>
                            </td>
                        </tr>
                        <!-- <tr class="table__tr">
                            <td class="table__td"><strong>Loop Mobile (JTM,Bharti Mobile Limited)</strong></td>
                            <td class="table__td"><strong>Loop Mobile</strong></td>
                            <td class="table__td"><strong>GSM 900</strong></td>
                        </tr>
                        <tr class="table__tr">
                            <td class="table__td"><strong>Optimus</strong></td>
                            <td class="table__td"><strong>900/1800/3G</strong></td>
                            <td class="table__td"><strong>900/1800/3G</strong></td>
                        </tr> -->
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'PartnerOperators',
};
</script>
